import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodeclimateComponent } from './simple-icons-codeclimate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodeclimateComponent ],
    exports:      [ SimpleIconsCodeclimateComponent ],
    bootstrap:    []
})
export class SimpleIconsCodeclimateModule {}
